import { render } from "./Rtpi.vue?vue&type=template&id=639e3d0d&scoped=true&lang=pug"
import script from "./Rtpi.vue?vue&type=script&lang=ts"
export * from "./Rtpi.vue?vue&type=script&lang=ts"

import "./Rtpi.vue?vue&type=style&index=0&id=639e3d0d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-639e3d0d"

export default script